var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPulldown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_24436",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24436",
    transform: "translate(-14 42) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_13620",
    "data-name": "\\u9577\\u65B9\\u5F62 13620",
    width: 24,
    height: 24,
    transform: "translate(18 14)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_ios_FILL0_wght400_GRAD0_opsz24",
    d: "M251.6-862l-1.6-1.6,7.4-7.4-7.4-7.4,1.6-1.6,9,9Z",
    transform: "translate(285 -845) rotate(180)",
    fill: "#a59785"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPulldown);
export default __webpack_public_path__ + "static/media/icon_pulldown.721d5de5e0edc68e8f934cb5c9fce041.svg";
export { ForwardRef as ReactComponent };